import { modelLabel } from "../../shared/models";
import { Badge } from "./ui";

/**
 * The model a run used, as a quiet badge. When it differs from its agent's default, the agent that handed it the task
 * chose it for that task, and the badge says so. `short` drops the "Claude" in front, for a line that is already full.
 * `title` says why this model, where it is no run's: the one picked for a schedule.
 */
export function ModelBadge({ model, defaultModel, short = false, title }: { model: string | null | undefined; defaultModel?: string | null; short?: boolean; title?: string }) {
  if (!model) return null;
  const chosen = Boolean(defaultModel && model !== defaultModel);
  const label = short ? modelLabel(model).replace(/^Claude /, "") : modelLabel(model);
  return (
    <span className="shrink-0" title={title ?? (chosen ? `Chosen for this task; its default is ${modelLabel(defaultModel!)}` : "Its agent's default model")}>
      <Badge>{chosen && !short ? `${label} · for this task` : label}</Badge>
    </span>
  );
}
